import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import Content, { Theme as ContentTheme } from 'components/base/Content'
import Link, { Theme as LinkTheme } from 'components/base/Link'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
import Title from 'components/base/Title'
import {
  QuestionText,
  QuestionTitle,
} from 'components/blocks/AskQuestion/styles'
import LocationIcon, { Theme as LocationIconTheme } from 'components/base/Icon/LocationIcon'
import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import ContactInfoDetails from 'components/blocks/ContactInfo/Details'
import AskQuestion from 'components/blocks/AskQuestion'
import LocationsGroup from 'components/blocks/LocationsGroup'

import { Location } from '../../components/App/styles'

const ContactScreen: React.FC = (): React.ReactElement => (
  <div>
    <HeaderMeta
      title='Contact | Insurance Lounge'
      description='Need to speak with one of our helpful representatives? Visit our contact page for more information on finding the right insurance policy for you.'
    />
    <PageHero theme={PageHeroTheme.contact}>Contact Us</PageHero>
    <Content short={true} center={true} margined={true}>
      <ContactInfoDetails />
    </Content>
    <Content short={true} center={true} margined={true}>
      <Paragraph>Insurance Lounge is committed to helping you make informed insurance decisions in a comfortable, one-stop shop environment. We provide auto, home, and other insurance options to let you see what will work best for you and your budget. Our transparent and friendly team will be here to help you each step of the way to ensure your satisfaction.</Paragraph>
    </Content>
    <Content id='storefronts' center={true} theme={ContentTheme.yellow}>
      <LocationIcon />
      <Title level={2} page={true}>
        Our Oregon Locations
      </Title>
      <Content short={true} center={true} margined={true}>
        <Paragraph>At Insurance Lounge, our retail <Link to='/locations/storefronts'>offices</Link> in Grants Pass, Eugene, Beaverton, and Medford are open seven days a week to assist you no matter where you are. Plus, our no-commission Insurance Concierges<sup>®</sup> are available to help you at any given time. Call us at 1-800-211-8660 to speak to an agent or <Link to='/quote/new'>request a quote online</Link>.</Paragraph>
      </Content>
      <LocationsGroup />
    </Content>
    <Content short={true} center={true} margined={true}>
      <QuestionTitle>Our Products</QuestionTitle>
      <QuestionText>Insurance Lounge offers great plans in all major insurance categories.</QuestionText>
      <Link to='/products' theme={LinkTheme.button}>Our Products</Link>
    </Content>
    <AskQuestion title='We’re Here, When You Need Us.'>
      In addition to our locations across Oregon, we can work with you over the phone or online at your convenience. Prospective clients can <Link to='/support/ask-a-question'>fill out a form</Link> to ask us questions and talk to one of our representatives.
    </AskQuestion>
    <Content short={true} center={true} margined={true}>
      <LocationIcon theme={LocationIconTheme.mail} />
      <Paragraph theme={ParagraphTheme.large}>Corporate Mailing Address</Paragraph>
      <Location href='https://www.google.com/maps/place//data=!4m2!3m1!1s0x54c579f506511665:0xf0764c95672795d7' target='_blank' rel='noopener noreferrer'>
        <Paragraph theme={ParagraphTheme.giant}>
          1221 NE 7th St,
          <br />
          Grants Pass, OR 97526
        </Paragraph>
      </Location>
    </Content>
  </div>
)

export default ContactScreen
